import React, { useContext } from "react";
import { Container, Tile, RegistrationYearHeader } from "./styles";
import { ModalMobile } from "@acko-tech/building-blocks.ui.modal";
import { Modal } from "@acko-tech/building-blocks.ui.modal";
import Context from "@components/useContext/context";

interface YearSelectorProps {
  showModal: boolean;
  setShowModal: (show: boolean) => void;
  yearOptions: Array<{ value: string; name: string }>;
  activeYear: string;
  setActiveYear: (year: Year) => void;
  isDesktop?: boolean;
}
interface Year {
  name: string;
  value: string;
}

const YearSelector = ({
  showModal,
  setShowModal,
  yearOptions,
  activeYear,
  setActiveYear
}: YearSelectorProps) => {
  const { isDesktop } = useContext(Context);

  const years = yearOptions.map(year => (
    <Tile
      key={year.value}
      selected={year.name === activeYear}
      onClick={() => {
        setActiveYear(year);
        setShowModal(false);
      }}
    >
      {year.name}
    </Tile>
  ));

  const modalHeader = (

    <RegistrationYearHeader>Select registration year</RegistrationYearHeader>
  );

  if (isDesktop) {
    return (
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        hideCloseButton={false}
        header={modalHeader}
        urlhash=""
        styles={{
          width: "472px",
          margin: "auto"
        }}
      >
        <Container>{years}</Container>
      </Modal>
    );
  }
  return (
    <ModalMobile
      show={showModal}
      onHide={() => setShowModal(false)}
      urlhash=""
      showOverlayBackground
      header={modalHeader}
    >
      <Container>
        {years}
      </Container>
    </ModalMobile>
  );
};

export default YearSelector;
